<template>
  <SideModal :sides="navs">
    <template :slot="'emenda'">
      <div class="side-body" v-if="emenda.id">
        <div class="row">
          <div class="col-xs-12">
            <label>Descrição</label>
            <p>
              {{ emenda.descricao }}
            </p>
          </div>
          <div class="col-xs-12 col-sm-6">
            <label>Vereador</label>
            <p>
              {{ emenda.vereador.nome }}
            </p>
          </div>
          <div class="col-xs-12 col-sm-6">
            <label>Nº do Processo</label>
            <p>
              {{ emenda.numero_processo }}
            </p>
          </div>
          <div class="col-xs-12 col-sm-6">
            <label v-if="emenda.processos_pagamento.length">
              Processos de Pagamento
            </label>
            <p>
              {{ getProcessosPagamento(emenda.processos_pagamento) }}
            </p>
          </div>
          <div class="col-xs-12">
            <label v-if="emenda.resumo_utilizacao">Utilização</label>
            <p>
              {{ emenda.resumo_utilizacao }}
            </p>
          </div>
          <div class="col-xs-12 col-sm-6">
            <label>Valor</label>
            <p>
              {{ formatarMoeda(Number(emenda.valor)) }}
            </p>
          </div>
          <div class="col-xs-12 col-sm-6">
            <label>Saldo</label>
            <p>
              {{ formatarMoeda(Number(emenda.saldo)) }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </SideModal>
</template>

<script>
import { SideModal } from '../common'
import { formatarMoeda } from '../../utils'

export default {
  components: { SideModal },
  props: {
    emenda: {
      type: Object,
      required: true
    },
    navs: {
      type: Array,
      required: true
    }
  },
  methods: {
    formatarMoeda,
    getProcessosPagamento(processos) {
      let retorno = ''

      processos.forEach(processo => {
        retorno += `${processo.numero_pagamento} (${formatarMoeda(
          Number(processo.valor)
        )}) \\`
      })

      return retorno.substring(0, retorno.length - 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/emendas/SideEmendas.vue